import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';
export var getAppLabelStatusBaseStyles = memoizeFunction(function (customStyles) {
    var defaultLabelStyles = {
        root: {
            display: 'flex',
            flexWrap: 'nowrap',
            alignItems: 'center',
            userSelect: 'none',
            padding: '0px 10px',
        },
        label: {
            fontWeight: 400,
            cursor: 'default !important',
        },
    };
    return mergeStyleSets(defaultLabelStyles, customStyles);
});
export var getAppLabelStatusBaseIconStyles = memoizeFunction(function (iconProps) {
    var defaultIconStyles = {
        root: {
            width: 20,
            height: 20,
            alignItems: 'center',
            paddingRight: 10,
        },
    };
    return mergeStyleSets(defaultIconStyles, iconProps.styles);
});
//# sourceMappingURL=AppLabelStatusBaseStyles.js.map